/* global _TL_ */

import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import bidEditorTemplate from '@bingads-webui-campaign-legacy/budget/template/bidEditor-2.pug';
import { bingadsGridColumn } from '@bingads-webui-component-legacy/bingads-grid/shared/column';
import { BaseAdGroupBidGrid } from '@bingads-webui-campaign-legacy/budget/view/base-bid-grid';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export class AdgroupBidGridView extends BaseAdGroupBidGrid {
  initialize({
    defaultBid,
    isBidEditable,
    activityLogger,
    newI18n,
  }) {
    const gridColumns = [
      {
        name: 'adGroup',
        title: i18n.get('ColumnHeader_AdGroup'),
        width: 300,
        property: _.property('Name'),
      },
      bingadsGridColumn({
        i18n,
        name: 'Bid',
        title: 'ColumnHeader_Bid',
        template: bidEditorTemplate,
        helpId: 'pop_BA_CampaignCreate_Budget_Bid',
        property: (item) => {
          return {
            Bid: item.Bid,
            currency: config.get('AccountCurrencyCode'),
            isBidEditable,
            i18n,
          };
        },
      }),
    ];

    super.initialize({
      defaultBid,
      gridColumns,
      gridName: 'adgroupBidGrid',
      activityLogger,
      girdAriaLabel: newI18n.getString(_TL_('Ad Group Bid Grid')),
    });
  }

  bidUpdated(e) {
    const newBidString = e.target.value;
    const selectedItem = this.grid.gridView.itemOfElement(e.target);

    if (!selectedItem) {
      return;
    }
    selectedItem.Bid = newBidString;

    this.validateBid(selectedItem);

    this.refreshGrid(this.grid.gridView.get('dataSource').data);
  }
}
